"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPREEDLY_SCRIPT_URL = exports.SpreedlyConfig = void 0;
exports.SpreedlyConfig = {
    DEV: 'MlG67JaqOvnV6ukLk7keE3YNRP1',
    PROD: '6vgyQXzDELv3IKo9sI94BLyur2p'
};
exports.SPREEDLY_SCRIPT_URL = 'https://core.spreedly.com/iframe/iframe-v1.min.js';
